<template>
  <div class="vx-input-group flex mb-0">
    <div class="vx-input-group-default flex-grow">
      <div>
        <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
          <div class="vs-con-input">
            <money class="vs-inputx vs-input--input" :type="type" autocomplete="new-password" maxlength="23"
              :placeholder="placeholder" :disabled="isDisabled" @input="onInput($event)" :value="value" :name="name"
              @blur.native="onFocusOut" v-bind="moneyAttributes"></money>
          </div>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'tel'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    moneyAttributes: {
      type: Object
    }
  },
  components: {
    Money
  },
  data() {
    return {
      amount: ''
    };
  },
  directives: { money: Money },
  mounted() {
    //
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    onFocusOut() {
      this.$emit('focusout')
    }
  }
};
</script>

<style scoped>
/* Add component-specific styles here */
</style>
